import { useSelector } from 'react-redux';
import {
  FaMessageLightSvgIcon,
  FaMessageSolidSvgIcon,
} from '../../../assets/icons/svgs';
import { colors } from '../../../theme/colors';
import { RootState } from '../../../redux/store';
import NotificationIndicator from '../../../components/Indicators/NotificationIndicator';
import {
  dotNavButtonNotificationStyle,
  numberedNavButtonNotificationStyle,
} from './styles';
import { isMobileScreen } from '../../../theme/spacing';
import { CSSProperties } from 'react';

interface MessagesNavigateButtonProps {
  size: number;
  isActive: boolean;
  style?: React.CSSProperties;
}

const dotPosition: CSSProperties = {
  top: -4,
  right: -8,
};

const numberPosition: CSSProperties = {
  top: -6,
  right: -14,
};

const MessagesNavigateButton = ({
  size,
  isActive,
  style,
}: MessagesNavigateButtonProps) => {
  const indicatorStats = useSelector(
    (state: RootState) => state.user.indicatorStats,
  );

  const unreadConversationsCount =
    indicatorStats?.unreadConversationsCount || 0;
  const unreadNotificationsCount =
    indicatorStats?.unreadNotificationsCount || 0;
  const unreadAssetWavesCount = indicatorStats?.unreadAssetWavesCount || 0;
  const hasVisitedChatsRoute = indicatorStats?.hasVisitedChatsRoute;

  const scheduledExchangesCount = indicatorStats?.scheduledExchangesCount || 0;
  const disputesExchangesCount = indicatorStats?.disputesExchangesCount || 0;
  const waitingForCurrentUserConfirmationCount =
    indicatorStats?.waitingForCurrentUserConfirmationCount || 0;
  const offersCurrentUserHasReceivedCount =
    indicatorStats?.offersCurrentUserHasReceivedCount || 0;

  const shouldShowNumber = unreadConversationsCount > 0;

  const hasAnyPendingExchaneActions =
    Boolean(scheduledExchangesCount) ||
    Boolean(disputesExchangesCount) ||
    Boolean(waitingForCurrentUserConfirmationCount) ||
    Boolean(offersCurrentUserHasReceivedCount);

  const hasUnreadNotifications =
    Boolean(unreadNotificationsCount) && !hasVisitedChatsRoute;

  const hasUnreadAssetWaves = Boolean(unreadAssetWavesCount);

  const shouldShowDot =
    !shouldShowNumber &&
    (hasAnyPendingExchaneActions ||
      hasUnreadNotifications ||
      hasUnreadAssetWaves);

  const MessageIcon = isActive ? FaMessageSolidSvgIcon : FaMessageLightSvgIcon;

  const getTextColor = () => {
    if (isMobileScreen) {
      return colors.textPrimary;
    }

    return isActive ? colors.textPrimary : colors.textGreyMedium;
  };

  return (
    <div style={{ position: 'relative', ...style }}>
      <div
        style={{
          display: 'inline-block',
          position: 'relative',
        }}
      >
        <MessageIcon
          style={{
            color: getTextColor(),
            position: 'relative',
            top: 1,
          }}
          size={size}
        />

        <NotificationIndicator
          isShown={shouldShowNumber || shouldShowDot}
          count={shouldShowNumber ? unreadConversationsCount : undefined}
          type="red"
          style={{
            position: 'absolute',
            ...(shouldShowNumber
              ? numberedNavButtonNotificationStyle
              : dotNavButtonNotificationStyle),
            ...(isMobileScreen
              ? {
                  border: 'none',
                  ...(shouldShowNumber ? numberPosition : dotPosition),
                }
              : {}),
          }}
        />
      </div>
    </div>
  );
};

export default MessagesNavigateButton;
